import { useEffect, useState } from "react";

import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ScheduleIcon from "@material-ui/icons/Schedule";
import UpdateIcon from "@material-ui/icons/Update";

import { useTranslation } from "react-i18next";
import Accordion from "../../components/Accordion";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { utcToLocal } from "../../utils/datetime";
import styles from "./index.module.scss";

export default function ReviewDateSummary({ id, updated = false, ...props }) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();

  const [currentReviewDate, setCurrentReviewDate] = useState([]);
  const [previousReviewDate, setPreviousReviewDate] = useState([]);

  useEffect(() => {
    // get review date details
    apiRequest
      .get(`/api/getSessionReviewDate?session_id=${id}`)
      .then(response => {
        const data = response.data.data;
        setCurrentReviewDate(data.current_review_date[0]);
        setPreviousReviewDate(data.previous_review_date);
      })
      .catch(error => {
        addNotification(t("error.errorGettingReviewDateSummary"), "error");
        console.error(error);
      });
  }, [updated]);

  return (
    <>
      {previousReviewDate && previousReviewDate.length > 0 && (
        <Accordion
          summary={
            <div className={styles.reviewDateSummary}>
              <div className={styles.reviewDateSummaryLeft}>
                <span>{t("updateCheckpoint.reviewDate")}</span>{" "}
                {previousReviewDate && previousReviewDate.length > 0 && (
                  <UpdateIcon color="primary" />
                )}
              </div>
              <div className={styles.reviewDateSummaryRight}>
                <div className={styles.reviewDateContent}>
                  <div className={styles.reviewDateContentDateTime}>
                    <div className={styles.date}>
                      <CalendarTodayIcon className={styles.icon} />{" "}
                      <span>
                        {utcToLocal(currentReviewDate.review_datetime).format(
                          "DD MMM YYYY"
                        )}
                      </span>
                    </div>
                    <div className={styles.time}>
                      <ScheduleIcon className={styles.icon} />{" "}
                      <span>
                        {utcToLocal(currentReviewDate.review_datetime).format(
                          "h:mm A"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          details={
            previousReviewDate &&
            previousReviewDate.length > 0 && (
              <div className={styles.reviewDateContent}>
                {currentReviewDate.reason && (
                  <div className={styles.reviewDateContentDescription}>
                    Reason: {currentReviewDate.reason}
                  </div>
                )}
                {previousReviewDate.map((reviewData, index) => (
                  <div className={styles.reviewDateContentItem} key={index}>
                    <div className={styles.reviewDateContentDateTime}>
                      <div className={styles.date}>
                        <CalendarTodayIcon className={styles.icon} />{" "}
                        <span>
                          {utcToLocal(reviewData.previous_review_date).format(
                            "DD MMM YYYY"
                          )}
                        </span>
                      </div>
                      <div className={styles.time}>
                        <ScheduleIcon className={styles.icon} />{" "}
                        <span>
                          {utcToLocal(reviewData.previous_review_date).format(
                            "h:mm A"
                          )}
                        </span>
                      </div>
                    </div>
                    <div className={styles.reviewDateContentDescription}>
                      {reviewData.reason ? `Reason: ${reviewData.reason}` : ''}
                    </div>
                  </div>
                ))}
              </div>
            )
          }
        />
      )}

      {!previousReviewDate ||
        (previousReviewDate.length === 0 && (
          <div
            className={styles.reviewDateSummary}
            style={{
              paddingTop: "20px",
              paddingBottom: "20px",
              borderBottom: "1px solid #9e9e9e",
            }}
          >
            <div className={styles.reviewDateSummaryLeft}>
              <span>{t("updateCheckpoint.reviewDate")}</span>{" "}
              {previousReviewDate && previousReviewDate.length > 0 && (
                <UpdateIcon color="primary" />
              )}
            </div>
            <div className={styles.reviewDateSummaryRight}>
              <div className={styles.reviewDateContent}>
                <div className={styles.reviewDateContentDateTime}>
                  <div className={styles.date}>
                    <CalendarTodayIcon className={styles.icon} />{" "}
                    <span>
                      {utcToLocal(currentReviewDate.review_datetime).format(
                        "DD MMM YYYY"
                      )}
                    </span>
                  </div>
                  <div className={styles.time}>
                    <ScheduleIcon className={styles.icon} />{" "}
                    <span>
                      {utcToLocal(currentReviewDate.review_datetime).format(
                        "h:mm A"
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
}
